// extracted by mini-css-extract-plugin
export default {"jobItem":"JobList_jobItem__pnVS0","jobLink":"JobList_jobLink__HI38R"};